import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Formatter from './formatter'
import zh from './lang/zh'
import en from './lang/en'

Vue.use(VueI18n)

const locale = 'zh' // default locale
const formatter = new Formatter({ locale })

export default new VueI18n({
    locale,
    formatter,
    messages: {
        en,
        zh
    }
})
